import { useState, useEffect, useCallback } from 'react';
import { useSection } from '../useSection';
import { SectionBuilder } from '../components/SectionBuilder';
import { authFetch } from '../../auth';

const SOL = '/api/cms/solutions';

export default function ProductCategory({ category, onBack, onRegisterSave, onRegisterDirty }) {
  const page = `product:${category}`;
  const [title, setTitle] = useState(category);

  const { data: headerData, setField: setHeaderField, saveSection: saveHeader, isDirty: headerDirty } =
    useSection(page, 'domain-header', 0);
  const { data: footerData, setField: setFooterField, saveSection: saveFooter, isDirty: footerDirty } =
    useSection(page, 'domain-footer', 1);

  useEffect(() => {
    authFetch(`${SOL}?lang=ko`).then((r) => r.json())
      .then((sols) => {
        const found = (sols || []).find((s) => s.slug === category);
        if (found) setTitle(found.title);
      })
      .catch(() => {});
  }, [category]);

  const save = useCallback(async () => {
    await saveHeader();
    await saveFooter();
  }, [saveHeader, saveFooter]);

  useEffect(() => {
    if (onRegisterSave) onRegisterSave(save);
    return () => { if (onRegisterSave) onRegisterSave(null); };
  }, [save, onRegisterSave]);

  const isDirty = useCallback(() => headerDirty() || footerDirty(), [headerDirty, footerDirty]);
  useEffect(() => {
    if (onRegisterDirty) onRegisterDirty(isDirty);
    return () => { if (onRegisterDirty) onRegisterDirty(null); };
  }, [isDirty, onRegisterDirty]);

  return (
    <div className="rp-admin-wrap">
      <h2 className="rp-admin-title">{title}</h2>

      {/* 도메인 헤더 */}
      <div style={{ marginBottom: 28, paddingBottom: 28, borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>도메인 헤더</span>
          <span style={{ fontSize: 12, color: '#888' }}>제품 목록 위에 표시 (소개, 응용 분야 등)</span>
        </div>
        <SectionBuilder value={headerData.content || ''} onChange={(v) => setHeaderField('content', v)} />
      </div>

      {/* 제품 목록 */}
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>제품 목록</span>
          <span style={{ fontSize: 12, color: '#888' }}>스펙 카드 섹션으로 제품을 구성하세요</span>
        </div>
        <SectionBuilder value={footerData.content || ''} onChange={(v) => setFooterField('content', v)} />
      </div>

      {onBack && (
        <div style={{ marginTop: '1.5rem' }}>
          <button type="button" className="btn-secondary" onClick={onBack}>← 응용 분야로 돌아가기</button>
        </div>
      )}
    </div>
  );
}
